import { Injectable } from '@angular/core';
import { Provider } from '@app/models';
import { ApiService } from '@app/services/api/api.service';
import { ProviderService } from '@app/services/api/provider.service';
import { FlashService } from '@app/services/flash.service';

import {
  AddAll,
  AddOne,
  AddResponsable,
  AddResponsableFail,
  AddResponsableSuccess,
  Create,
  CreateFail,
  CreateManagement,
  CreateManagementFail,
  CreateManagementSuccess,
  CreateSuccess,
  DeleteResponsable,
  DeleteResponsableFail,
  DeleteResponsableSuccess,
  GetUploadLink,
  GetUploadLinkFail,
  Load,
  LoadByFollowGroup,
  LoadByFollowGroupFail,
  LoadByFollowGroupSuccess,
  LoadById,
  LoadFail,
  LoadSuccess,
  LoadSupplier,
  ProviderActionTypes,
  ProviderCreateRebate,
  ProviderCreateRebateFail,
  ProviderCreateRebateSuccess,
  ProviderRebate,
  ProviderRebateFail,
  ProviderRebateSuccess,
  RemoveOne,
  RemoveOneFailed,
  RemoveOneSuccess,
  Search,
  SearchFail,
  SearchFailPro,
  SearchPro,
  SearchSuccess,
  SearchSuccessPro,
  Update,
  UpdateFail,
  UpdateManagement,
  UpdateManagementFail,
  UpdateManagementSuccess,
  UpdateSuccess,
  UploadFile,
  UploadFileFail,
  UploadFileSuccess,
  UploadProcessFail,
  UploadProcessSuccess,
  UploadProcessUpdate,
  SyncMdm,
  SyncMdmSuccess,
  SyncMdmFail
} from '@core/actions/provider.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  catchError,
  concatMap,
  map,
  switchMap,
  tap
} from 'rxjs/operators';

@Injectable()
export class ProviderEffects {
  @Effect()
  loadSupplier$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSupplier>(ProviderActionTypes.LoadSupplier),
    switchMap(action => {
      return this.providersApi.getSupplier(action.followGroupId).pipe(
        map((providers: any) => new LoadSuccess(providers)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ProviderActionTypes.Load),
    switchMap(action => {
      // return this.providersApi.getSupplier(action.page, action.filterValue, action.viewMode).pipe(
      return this.providersApi.getSupplier().pipe(
        map((providers: any) => new LoadSuccess(providers)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  syncMdm$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ProviderActionTypes.SyncMdm),
    switchMap(action => {
      // return this.providersApi.getSupplier(action.page, action.filterValue, action.viewMode).pipe(
      return this.providersApi.syncMdm().pipe(
        map((providers: any) => new SyncMdmSuccess(providers)),
        catchError(error => of(new SyncMdmFail(error)))
      );
    })
  );

  //@Effect({ dispatch: false })
  //loadById$ = this.actions$.pipe(
  //ofType<LoadById>(ProviderActionTypes.LoadById),
  //switchMap(() => {
  //return this.providersApi.get().pipe(
  //map((providers: Provider[]) => new LoadSuccess(providers)),
  //catchError(error => of(new LoadFail(error)))
  //);
  //})
  //);

  @Effect()
  loadById$ = this.actions$.pipe(
    ofType<LoadById>(ProviderActionTypes.LoadById),
    switchMap(action => {
      return this.providersApi.getById(action.ProviderId).pipe(
        map((provider: Provider) => {
          //return new LoadSuccess([provider]);
          return new AddAll([provider]);
        }),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadbyfollowgroup$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByFollowGroup>(ProviderActionTypes.LoadByFollowGroup),
    switchMap(action => {
      return this.providersApi.getByFollowGroup(action.id, action.gerencyMode).pipe(
        map((providers: Provider[]) => new LoadByFollowGroupSuccess(providers)),
        catchError(error => of(new LoadByFollowGroupFail(error)))
      );
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(ProviderActionTypes.LoadSuccess),
    map(action => new AddAll(action.providers))
  );

  @Effect()
  providerRebate$: Observable<Action> = this.actions$.pipe(
    ofType<ProviderRebate>(ProviderActionTypes.ProviderRebate),
    map(action => action.FollowId),
    switchMap(followId => this.providersApi.getProvidersRebate(followId).pipe(
      map(action => new ProviderRebateSuccess(action)),
      catchError(error => of(new ProviderRebateFail(error)))
    ))
  )

  @Effect()
  providerCreateRebate$: Observable<Action> = this.actions$.pipe(
    ofType<ProviderCreateRebate>(ProviderActionTypes.ProviderCreateRebate),
    map(action => action),
    switchMap(actions => this.providersApi.createRebates(actions.FollowId, actions.data).pipe(
      map(action => new ProviderCreateRebateSuccess(action)),
      catchError(error => of(new ProviderCreateRebateFail(error)))
    ))
  )

  @Effect({ dispatch: false })
  providerCreateRebateSuccess$ = this.actions$.pipe(
    ofType<ProviderCreateRebateSuccess>(ProviderActionTypes.ProviderCreateRebateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Rebate actualizado' });
    })
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(ProviderActionTypes.Create),
    map(action => action.provider),
    switchMap(provider =>
      this.providersApi.create(provider).pipe(
        map((savedProvider: Provider) => new CreateSuccess(savedProvider)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(ProviderActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Proveedor creado' });
      return new AddOne(action.provider);
    })
  );

  @Effect({ dispatch: false })
  createFail$ = this.actions$.pipe(
    ofType<CreateFail>(ProviderActionTypes.CreateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo crear el proveedor',
        type: 'danger'
      })
    )
  );

  @Effect()
  providerUpdate$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(ProviderActionTypes.ProviderUpdate),
    map(action => [action.id, action.rut]),
    concatMap(([id, name]) =>
      this.providersApi.update(id, name).pipe(
        map(product => {
          this.fs.emit({
            type: 'success',
            message: 'Proveedor editado correctamente'
          });
          return new UpdateSuccess(product);
        }),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  @Effect()
  updateManagement$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateManagement>(ProviderActionTypes.UpdateManagement),
    map(action => [action.id, action.data]),
    concatMap(([id, data]) =>
      this.providersApi.updateProviderManagement(id, data).pipe(
        map(product => {
          this.fs.emit({
            type: 'success',
            message: 'Proveedor editado correctamente'
          });
          return new UpdateManagementSuccess(product);
        }),
        catchError(error => of(new UpdateManagementFail(error)))
      )
    )
  );

  @Effect()
  createManagement$: Observable<Action> = this.actions$.pipe(
    ofType<CreateManagement>(ProviderActionTypes.CreateManagement),
    map(action => action.data),
    switchMap(data =>
      this.providersApi.createProviderManagement(data).pipe(
        map((savedProvider: any) => new CreateManagementSuccess(savedProvider)),
        catchError(error => of(new CreateManagementFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  createManagementSuccess$ = this.actions$.pipe(
    ofType<CreateManagementSuccess>(ProviderActionTypes.CreateManagementSuccess),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'Gerencia creada con correctamente',
        type: 'success'
      })
    )
  );

  @Effect({ dispatch: false })
  createManagementFail$ = this.actions$.pipe(
    ofType<CreateManagementFail>(ProviderActionTypes.CreateManagementFail),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo crear la gerencia',
        type: 'danger'
      })
    )
  );

  @Effect()
  addResponsable$: Observable<Action> = this.actions$.pipe(
    ofType<AddResponsable>(ProviderActionTypes.AddResponsable),
    map(action => action.data),
    switchMap(data =>
      this.providersApi.addUserProvider(data).pipe(
        map((savedProvider: any) => new AddResponsableSuccess(savedProvider)),
        catchError(error => of(new AddResponsableFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  addResponsableSuccess$ = this.actions$.pipe(
    ofType<AddResponsableSuccess>(ProviderActionTypes.AddResponsableSuccess),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'Usuario/s asignado correctamente',
        type: 'success'
      })
    )
  );

  @Effect({ dispatch: false })
  addResponsableFail$ = this.actions$.pipe(
    ofType<AddResponsableFail>(ProviderActionTypes.AddResponsableFail),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo asignar el usuario',
        type: 'danger'
      })
    )
  );

  @Effect()
  deleteResponsable$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteResponsable>(ProviderActionTypes.DeleteResponsable),
    map(action => [action.id, action.data]),
    concatMap(([id, data]) =>
      this.providersApi.deleteUserProvider(id, data).pipe(
        map(product => {
          this.fs.emit({
            type: 'success',
            message: 'Usuario desasignado correctamente'
          });
          return new DeleteResponsableSuccess(product);
        }),
        catchError(error => of(new DeleteResponsableFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  deleteResponsableFail$= this.actions$.pipe(
    ofType<DeleteResponsableFail>(ProviderActionTypes.DeleteResponsableFail),
    map((action) => {
      if(action.data.error.error.message){
        this.fs.emit({ type: 'danger', message: action.data.error.error.message });
      }else{
        this.fs.emit({ type: 'danger', message: 'No se puede actualizar el proveedor' });
      }
    })
  );

  @Effect({ dispatch: false })
  updateManagementFail$= this.actions$.pipe(
    ofType<UpdateManagementFail>(ProviderActionTypes.UpdateManagementFail),
    map((action) => {
      if(action.data.error.error.message){
        this.fs.emit({ type: 'danger', message: action.data.error.error.message });
      }else{
        this.fs.emit({ type: 'danger', message: 'No se puede actualizar el proveedor' });
      }
    })
  );

  @Effect()
  getUploadLink$: Observable<Action> = this.actions$.pipe(
    ofType<GetUploadLink>(ProviderActionTypes.GetUploadLink),
    map(action => action.file),
    switchMap(file => {
      return this.api.getProvidersUploadLink(file).pipe(
        map((record: any) => {
          return new UploadFile(record.signedUrl, record.id, file);
        }),
        catchError(e => of(new GetUploadLinkFail()))
      );
    })
  );

  @Effect()
  uploadFile$: Observable<Action> = this.actions$.pipe(
    ofType<UploadFile>(ProviderActionTypes.UploadFile),
    map(action => [action.uploadUrl, action.FileId, action.file]),
    switchMap(([uploadUrl, FileId, file]) => {
      return this.api.uploadFile(uploadUrl, file).pipe(
        map(record => {
          return new UploadFileSuccess(FileId);
        }),
        catchError(e => of(new UploadFileFail(e)))
      );
    })
  );

  @Effect()
  uploadFileSuccess$ = this.actions$.pipe(
    ofType<UploadFileSuccess>(ProviderActionTypes.UploadFileSuccess),
    map(action => action.FileId),
    switchMap((FileId: number) => {
      return this.api
        .notifyFileUpload(FileId, { processType: 'Providers' })
        .pipe(
          map(record => {
            return new UploadProcessUpdate({
              status: 'pending',
              message: 'Procesando maestra de proveedores...'
            });
          }),
          catchError(e => of(new UploadProcessFail(e)))
        );
    })
  );

  @Effect()
  UploadProcessFail$ = this.actions$.pipe(
    ofType<UploadProcessFail>(ProviderActionTypes.UploadProcessFail),
    map((action) => {
      if(action.error.message){
        this.fs.emit({ type: 'danger', message: action.error.message });
      }else{
        this.fs.emit({ type: 'danger', message: 'No se pudo cargar proveedores' });
      }
      const page = 0;
      return new Load(page);
    })
  );

  @Effect()
  uploadFileFail$ = this.actions$.pipe(
    ofType<UploadFileFail>(ProviderActionTypes.UploadFileFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo cargar proveedores',
        type: 'danger'
      })
    )
  );

  @Effect()
  uploadProcessSuccess$ = this.actions$.pipe(
    ofType<UploadProcessSuccess>(ProviderActionTypes.UploadProcessSuccess),
    map(() => {
      this.fs.emit({ type: 'success', message: 'Proveedores actualizados' });
      const page = 0;
      return new Load(page);
    })
  );

  @Effect()
  search$ = this.actions$.pipe(
    ofType<Search>(ProviderActionTypes.Search),
    map(action => [action.data, action.FollowId]),
    switchMap(([data, FollowId]) =>
      this.providersApi.search(data, FollowId).pipe(
        map((ProviderIds: number[]) => new SearchSuccess(ProviderIds)),
        catchError(error => of(new SearchFail(error)))
      )
    )
  );

  @Effect()
  searchPro$ = this.actions$.pipe(
    ofType<SearchPro>(ProviderActionTypes.SearchPro),
    map(action => [action.data, action.FollowId]),
    switchMap(([data, FollowId]) =>
      this.providersApi.searchPro(data, FollowId).pipe(
        map((ProviderIds: number[]) => new SearchSuccessPro(ProviderIds)),
        catchError(error => of(new SearchFailPro(error)))
      )
    )
  );

  @Effect()
  removeOne$ = this.actions$.pipe(
    ofType<RemoveOne>(ProviderActionTypes.RemoveOne),
    map(action => action.id),
    concatMap((id) => {
      return this.providersApi.delete(id).pipe(
        map(() => {
          this.fs.emit({ type: 'success', message: 'Proveedor eliminado' });
          return new RemoveOneSuccess(id);
        }),
        catchError(error => {
          this.fs.emit({ type: 'danger', message: 'Hubo un error al eliminar el proveedor' });
          return of(new RemoveOneFailed(error));
        })
      )
    })
  )

  @Effect()
  removeOneSuccess$ = this.actions$.pipe(
    ofType<RemoveOneSuccess>(ProviderActionTypes.RemoveOneSuccess),
    map((action) => {
         window.location.reload()
        return new Load(0, 0)
    })
  );  

  // this.fs.emit({ type: 'success', message: 'Providers actualizados' });

  // @Effect()
  // archived$: Observable<Action> = this.actions$.pipe(
  //   ofType<Archived>(ProviderActionTypes.Archived),
  //   map(action => action.id),
  //   exhaustMap(id => {
  //     return this.providersApi.
  //   })
  // )

  constructor(
    private actions$: Actions,
    private providersApi: ProviderService,
    private api: ApiService,
    private fs: FlashService
  ) {}
}
